import React from 'react'

import { LinkEntry, LinkEntryDraft } from 'shared/api/requests/aiBusinessKnowledge/schemas'

import { LinkEntryLoader } from './components/LinkEntryLoader'
import { LinkForm } from './components/LinkForm'
import { PlainTextEditor } from './components/PlainTextEditor'
import { useProcessLinkToText } from './hooks/useProcessLinkToText'

interface LinkWithPreviewEditorProps {
  entry: LinkEntry | null
  onSubmit: (entry: LinkEntryDraft | LinkEntry, hasBeenChanged?: boolean) => void
  onBackToReadMode: () => void
  isLoading: boolean
}

export const LinkWithPreviewEditor = ({
  entry,
  onSubmit,
  onBackToReadMode,
  isLoading,
}: LinkWithPreviewEditorProps) => {
  const { isProcessing, isLastStepOfLoading, processedEntry, processLink, error } =
    useProcessLinkToText({
      entry,
    })

  if (isProcessing || isLastStepOfLoading) {
    return <LinkEntryLoader showLastStep={isLastStepOfLoading} />
  }

  if (!entry && !processedEntry) {
    return <LinkForm error={error} onSubmit={processLink} />
  }

  return (
    <PlainTextEditor
      onSubmit={onSubmit}
      onBackToReadMode={onBackToReadMode}
      onRescan={processLink}
      processedEntry={processedEntry}
      existingEntry={entry}
      isLoading={isLoading}
      error={error}
    />
  )
}
